<div 
    *ngFor="let contentElement of element.content" 
    [ngStyle]="getElementStyle(contentElement)"
>
    <element-render 
        [contentElement]="contentElement" 
        [questionState]="questionState"
        [isLocked]="isLocked"
        [contentElement]="contentElement"
        [questionPubSub]="questionPubSub"
        [isShowSolution]="isShowSolution"
     data-ui-name="Element render" data-ui-component="element-render-template" data-testid="element-render-template-element-render"></element-render>
</div> 
